import { AbstractControl, ValidatorFn } from '@angular/forms';

export function equalityValidator(targetControl: AbstractControl): ValidatorFn {
  return (control: AbstractControl): EqualityError => {
    const targetValue = targetControl.value;
    if (control.value !== targetValue) {
      return { equality: 'failed' };
    }

    return null;
  };
}

export interface EqualityError {
  equality: 'failed';
}

export function hasEqualityError(errors: any): errors is EqualityError {
  return (errors as EqualityError).equality !== undefined;
}
